import request from "@/utils/request"
//获取计费模型发送记录
export function GetSendLogPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/ChargingConfig/GetSendLogPageList",
    method: "post",
    data
  })
}
